<div class="div-assign-provider">
    <div style="width: 100%;">
      <div class="card list-providers" >
        
        <div class="card-body"
            style="height: 500px; overflow-y: scroll; padding-bottom: 80px;"
            infinite-scroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="300"
            [infiniteScrollDisabled]="!hasMoreProviders"
            [scrollWindow]="false"
            (scrolled)="loadMoreProviders()">
          <div class="mb-3 row">
            <h2 class="col-sm-6  align-self-center  h2-tilte">
              <strong (click)="hidereasigncard()" style="cursor: pointer;">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
                {{  "Supplier reassignment" | translate }}
              </strong>
            </h2>
            <div class="col-sm-6">
              <button type="button" class="btn secundary-btn secundary-btn-fw" [ngClass]="{'active': polygonFilter}" (click)="activatePolygonFilter()">
                <strong>{{ 'Coverage Area' | translate }}</strong>
              </button>
            </div>
          </div>
      <div class="search-input" >
          <strong>Buscar:</strong>
           <div style="width: 65%; display: flex; justify-content: center; align-items: center; gap:10px">
              <button (click)="restartProviders()" style="background-color:white; width:30px; height: 30px; border-radius: 50%; box-shadow: inset 0 1px 1px rgba(0,0,0,.075);"><i class="fas fa-sync"></i></button>
              <mat-form-field style="width: 95%;" appearance="fill">
              <input
                type="text"
                matInput
                placeholder="Buscar proveedor"
                [formControl]="providerCtrl"
                [matAutocomplete]="auto">
                
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="onProviderSelected($event.option.value)">
                <mat-option *ngFor="let provider of filteredProviders" [value]="provider" style="display: flex; align-items: center;">
                  <span style="font-weight: bold; font-size: 10px;"> {{provider.site_name}}</span> - <span style="font-size: 10px;">{{ provider.name }} </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
      
            
      </div>

          <div class="card internal-card mb-3" *ngFor="let provider of providers" >
            <div class="card-body col" (mouseenter)="onProviderHover(provider)" (mouseleave)="onProviderHoverOut(provider)">
              <div class="row mb-2">
                <div class="col">
                  <div style="display: flex; width: 100%; justify-content: space-between;">
                    <strong>{{ provider?.provider_site?.id }} {{ provider?.provider_site?.name }}</strong>
                    <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 1">
                      {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}}
                    </strong>
                    <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 2">
                      {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}} / Km
                    </strong>
                    <strong *ngIf="!provider?.provider?.price">
                      N/A
                    </strong>
                  </div>
                  <div style="display: flex; width: 100%; justify-content: space-between;">
                    <div>
                      <span style="font-size: 0.9rem;">{{ provider?.provider?.id }} {{ provider?.provider?.name }}</span>
                      <i *ngIf="provider.users" class="fa fa-mobile fa-fw big-icon" (click)="showProviderUsers(provider)" style="cursor: pointer;"></i>
                    </div>
                    <span *ngIf="provider.priority">
                      <i class="fa fa-star" style="color: gold;"></i>
                      {{ provider.priority }}
                    </span>
                  </div>

                  <br>
                  <span style="font-size: 0.7rem;"  *ngIf="provider?.city!='' && provider?.state!=''">{{ provider?.city}}, {{provider?.state}}</span>
                  <br>
                  <span style="font-size: 0.7rem;">{{ provider?.provider?.cabin_emails }}</span>
                  <br>
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <span *ngIf="coveragePrice.id == provider?.assistancePrice_id" style="font-size: 0.7rem;">{{ "Attention Times" | translate }} {{ coveragePrice?.hour_end }} - {{ coveragePrice?.hour_start }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ "Cancellation" | translate }} {{ coveragePrice?.price_cancellation }}%</span>
                  </div>
                </div>
                <div class="col">
                  <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                    <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{provider?.provider?.currency_symbol}} {{ coveragePrice?.price_extra != null ? coveragePrice?.price_extra : '-'  }}/km</span>
                  </div>
                </div>
                <div class="col">
                  <div *ngFor="let contactPhone of ((provider.provider_site.cabin_phones || '')).split(',')">
                    <span>
                      <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/phone.svg' | company" alt=""> {{ contactPhone }}
                    </span>
                  </div>
                </div>
                <div class="col">
                  <span *ngIf="provider?.coverage?.coverage_type == 1">
                    {{ 'Plane' | translate }} {{ provider?.coverage?.plane }}
                  </span>
                  <span *ngIf="provider?.coverage?.coverage_type == 2">
                    {{ 'Foreign' | translate }}
                  </span>
                </div>
                <div class="col" (click)="test(provider)">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/location2.svg' | company" alt=""> {{ provider?.city }}
                </div>
              
                <div class="col-sm-1 text-end" (click)="onSelectProvider(provider)">
                  <img class="img-pointer" *ngIf="provider.id != idProviderSelected" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_more.svg' | company" alt="">
                  <img class="img-pointer" *ngIf="provider.id == idProviderSelected" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_less.svg' | company" alt="">
                </div>
              </div>
  
            </div>

            <div class="card-body pt-0" *ngIf="provider.id == idProviderSelected">
            <form class="form-horizontal" #form="ngForm">
              <div class="row mb-2">
                <div class="col">
                  <strong>{{'Reassign Provider Reason' | translate }}:</strong>
                </div>
              </div>
              <div class="div-comment-provider w-100">
                <select name="reason_to_reassign" class="form-control"
                [(ngModel)]="reason_select"
                 required>
                 <option *ngFor="let reason of reasons" [ngValue]="reason.description_es">
                  {{ reason.description_es }}
                </option>
                </select>
              <!-- Para agregar la reassignacion de buca -->
              </div>
              <div class="row mb-3" *ngIf="assistance_plan_service?.buca_apply == 1">

                <div class="col-md-8">
                  <div>
                    <label class="control-label">
                      {{ 'Dentist' | translate }}:
                    </label>
                    <div>
                      <select name="status" class="form-control" required
                        [(ngModel)]="new_provider_id">
                        <option hidden [ngValue]="null">--- Seleccione un Odontólogo --- </option>
                        <option *ngFor="let user of siteUsers" [ngValue]="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-8  date-content">
                  <div>
                    <label class="control-label">
                      {{ 'Address' | translate }}:
                    </label>
                    <div>
                      <textarea rows="2" cols="5" class="form-control" placeholder="{{ 'Address' | translate }}"
                        [(ngModel)]="address" name="address" required>
                      </textarea>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 date-content">
                  <label class="control-label">
                    {{'Appointment date and time' | translate}}:
                  </label>
                  <p-datepicker [showIcon]="true" [required]="true" name="dateControl" dateFormat="dd/mm/yy" [(ngModel)]="appointmentDate" [showTime]="true" hourFormat="12">
                  </p-datepicker>
                </div>
              </div>
              <div class="row mb-3" *ngIf="assistance_plan_service?.sinister_apply == 1">
                <div class="col-md-8">
                  <div>
                    <label class="control-label">
                      {{ 'Provider' | translate }}:
                    </label>
                    <div>
                      <select name="status" class="form-control" required
                        [(ngModel)]="new_provider_id">
                        <option [ngValue]="null">--- Seleccione un Proveedor --- </option>
                        <option *ngFor="let user of siteUsers" [ngValue]="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="div-comment-provider w-100"  *ngIf="editticket.provider_status !== 3">
                <textarea rows="5" cols="10" class="form-control" placeholder="{{ 'Write a comment' | translate }}"
                  [(ngModel)]="comment" name="comment" required>
                </textarea>
              </div>
              <div class="body-card-provider">
                <button class="btn primary-btn-green btn primary-btn-fw m-0">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company" alt="">
                  {{ 'To call' | translate }}
                </button>
                <button class="btn primary-btn btn primary-btn-fw m-0"  [disabled]="form.form.invalid || form.form.pending" (click)="Generar()"> {{ 'Assign' | translate }} </button>
              </div>
            </form>
            </div>
          </div>
          <div class="card internal-card " style="height: 160px;" *ngIf='isLoading'>
            <div class="card-body col" >
              <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                <div class="col" style="display: flex; gap: 10px; justify-content: space-between;">
                  <div class="skeleton" style="width: 65%; height: 20px;"></div>
                  <div class="skeleton" style="width: 10%; height: 16px;"></div>
                </div>
                <div class="col" style="display: flex; gap: 10px;">
                  <div class="skeleton" style="width: 50%; height: 20px;"></div>                
                </div>
                <div class="col" style="display: flex; flex-direction: column; gap: 10px;">
                  <div class="skeleton" style="width: 30%; height: 20px;"></div>
                  <div class="skeleton" style="width: 20%; height: 20px;"></div>
                </div>
              </div>
            </div>
        </div>
          <div class="row" class="float-div">
            <div class="col text-center" style="display: flex; justify-content: center; align-items: center; height: 100%">
              <button class="btn secundary-btn secundary-btn-fw" (click)="seeMoreProvider()"><strong> {{ 'See more providers' | translate }} </strong></button>
            </div>
          </div>
        </div>
      </div>
    </div>


    
    <div class="div-map-info">
      <div style="width: 100%; height: 64vh;">
        <p-gmap *ngIf="providers.length"
          [options]="mapOptions" [style]="{width:'100%', height:'100%'}"
          [overlays]="mapOverlays" (onMapReady)="setMap($event)" #providersMap>
        </p-gmap>
      </div>
      <div class="card internal-card" style="width: 95%;">
        <div class="card-body">
          <div class="div-info-assistancecase">
            <div class="div-data-vehicle-50">
              <img class="img-details" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company" alt="">
              <hr>
              <p><strong>{{ 'Vehicle data' | translate }}:</strong></p>
              <p *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elsebrand">{{ assistanceSaleCar?.brand_description }}</p>
              <ng-template #elsebrand>
                <p>{{ servicegroup?.brand_description || servicegroup?.car_brand_desc || servicegroup?.car_model?.brand?.name }}</p>
              </ng-template>
              <p *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elsemodel">{{ assistanceSaleCar?.model_description }}</p>
              <ng-template #elsemodel>
                <p>{{ servicegroup?.model_description || servicegroup?.car_model_desc || servicegroup?.car_model?.name }}</p>
              </ng-template>
            </div>
            <div class="div-data-vehicle-50">
              <p><strong>{{ 'Car Year' | translate }}:</strong></p>
              <hr style="margin: 0 3px;">
              <p *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elseyear">{{ assistanceSaleCar?.car_year }}</p>
              <ng-template #elseyear>
                <p>{{ servicegroup?.car_year }}</p>
              </ng-template>
            </div>
          </div>
          <div class="div-info-assistancecase">
            <div class="div-data-vehicle-50" style="padding-left: 67px;">
              <p><strong>{{ 'Car Plate' | translate }}:</strong></p>
              <hr style="margin: 0 3px;">
              <p *ngIf="assistance_plan_service.sinister_apply === 1 && servicegroup.service.category.id==2; else elseplate">{{ assistanceSaleCar?.car_plate }}</p>
              <ng-template #elseplate>
                <p>{{ servicegroup?.car_plate }}</p>
              </ng-template>
            </div>
            <div class="div-data-vehicle-50">
              <p><strong>{{ 'Car Color' | translate }}:</strong></p>
              <hr style="margin: 0 3px;">
              <p>{{ assistanceSaleCar?.color_description || servicegroup?.color_description || servicegroup?.car_color_desc }}</p>
            </div>
          </div>
          <br>
  
          <div class="div-info-assistancecase">
            <div class="div-data-vehicle-100">
              <img class="mrg-rg" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/client_data.svg' | company" alt="">
              <hr>
              <p><strong>{{ 'Data of the Holder' | translate }}</strong></p>
              <hr style="margin: 0 3px;">
              <p>{{ assistancecase?.member?.name }}</p>
            </div>
          </div>
          <div class="div-info-assistancecase">
            <div class="div-data-vehicle-75">
              <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company" alt="">
              <hr>
              <!-- <p><strong> {{ 'Link location' | translate }}: </strong></p>
              <hr style="margin: 0 3px;">
              <p style="color: #70BE21; cursor: pointer;"><u> {{ 'Client location' | translate }} </u></p> -->





            <div class="row">
              <div [ngClass]="have_coordinates ? 'col-md-6' : 'col-12'">
                <p-messages [enableService]="false" [(value)]="msgs" [closable]="false"></p-messages>
              </div>
            
              <div *ngIf="have_coordinates" class="col-md-6 d-flex align-items-center">
               
                <p><strong> {{ 'Link location' | translate }}: </strong></p>
                <hr style="margin: 0 3px;">
                <p (click)="openLinkLocationCustomer()" style="color: #70BE21; cursor: pointer;"><u> {{ 'Client location' | translate }} </u></p>
    
    
              </div>
            </div>





            </div>
            <div class="div-data-vehicle-25" (click)="copyText(assistancecase.phone)">
              <img style="width: 22px;" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" alt="">
              <hr style="margin: 0 3px;">
              <p style="color: #70BE21; cursor: pointer; display: flex; align-items: center; justify-content: center;">
                <u>{{ assistancecase?.phone }}</u>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  



<!-- See more providers -->
<p-dialog [(visible)]="showSeeMoreProviders" [modal]="true" [draggable]="false" [blockScroll]="true" [positionTop]="100"
(onHide)="hideProviderCard()" [style]="{width: '80vw', height: '50vw'}">
  <ng-template pTemplate="header">
    
  {{ 'Search providers' | translate }}

  </ng-template>

<div class="container">
  <form class="row"  #form="ngForm">

    <div class="col-sm-4">
      <label class="control-label">{{ 'Country' | translate }}</label>
      <select name="country_" class="form-control" (ngModelChange)="onSelectCountry($event)" [(ngModel)]="country_id" required>
        <option [ngValue]="null">---</option>
        <option [ngValue]="0">Todos los Paises</option>
        <option *ngFor="let country of countries" [ngValue]="country.id">
          {{ country.name }}
        </option>
        
      </select>
    </div>

    <div class="col-sm-4">
      <label class="control-label">{{ 'State' | translate }}</label>
      <select [disabled]="country_id == 0" name="state_origin_id" class="form-control" (ngModelChange)="onSelectState($event)"
        [(ngModel)]="state_id" required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let state of states" [ngValue]="state.id">
          {{ state.name }}
        </option>
      </select>
    </div>
    <div class="col-sm-4">
      <label class="control-label">{{ 'District' | translate }}</label>
      <select  [disabled]="country_id == 0" name="state_district_origin_id" class="form-control" 
        [(ngModel)]="state_district_id" required>
        <option [ngValue]="null">---</option>
        <option *ngFor="let state of statesDistrict" [ngValue]="state.id">
          {{ state.name }}
        </option>
      </select>
    </div>

    <div class="col-sm-4">
      <label class="control-label">{{ 'Provider' | translate }}</label>
      <input type="text" class="form-control" [(ngModel)]="searchProvider" name="searchProvider">
    </div>

    <div class="col-sm-4 pt-4">
      <button [disabled]="form.form.invalid" type="button"  class="btn primary-btn btn primary-btn-fw m-0" (click)="getProviders()"> {{ 'Filter' | translate }} </button>
    </div>
  </form>
  <div  *ngIf="providersAll.length>0"  class="row mt-3">
    <div class="col">
      <div class="card internal-card mb-3"*ngFor="let provider of providersAll">
        <div class="card-body col">
          <div class="row mb-2">
            <div class="col">
              <div style="display: flex; width: 100%; justify-content: space-between;">
                <strong>{{ provider?.provider_site?.id }} {{ provider?.provider_site?.name }}</strong>
                <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 1">
                  {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}}
                </strong>
                <strong *ngIf="provider?.provider?.price && provider?.coverage?.coverage_type == 2">
                  {{provider?.provider?.currency_symbol}} {{provider?.provider?.price | number: "1.2-2"}} / Km
                </strong>
                <strong *ngIf="!provider?.provider?.price">
                  N/A
                </strong>
              </div>
              <span style="font-size: 0.9rem;">{{ provider?.provider?.id }} {{ provider?.provider?.name }}</span>
              <br>
              <span style="font-size: 0.7rem;">{{ provider?.provider?.cabin_emails }}</span>
              <br>
              <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                <span *ngIf="coveragePrice.id == provider?.assistancePrice_id" style="font-size: 0.7rem;">{{ "Attention Times" | translate }} {{ coveragePrice?.hour_end }} - {{ coveragePrice?.hour_start }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{ "Cancellation" | translate }} {{ coveragePrice?.price_cancellation }}%</span>
              </div>
            </div>
            <div class="col">
              <div *ngFor="let coveragePrice of provider?.coverage?.assistancePrices">
                <span *ngIf="coveragePrice.id == provider?.assistancePrice_id">{{provider?.provider?.currency_symbol}} {{ coveragePrice?.price_extra != null ? coveragePrice?.price_extra : '-'  }}/km</span>
              </div>
            </div>
            <div class="col">
              <div *ngFor="let contactPhone of ((provider.provider_site.cabin_phones || '')).split(',')">
                <span>
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/phone.svg' | company" alt=""> {{ contactPhone }}
                </span>
              </div>
            </div>
            <div class="col">
              <span *ngIf="provider?.coverage?.coverage_type == 1">
                Plano {{ provider?.coverage?.plane }}
              </span>
              <span *ngIf="provider?.coverage?.coverage_type == 2">
                Foráneo
              </span>
            </div>
            <div class="col" (click)="test(provider)">
              <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/location2.svg' | company" alt=""> {{ provider?.city }}
            </div>
            <div class="col-sm-1 text-end" (click)="onSelectProvider(provider, true)">
              <img class="img-pointer" *ngIf="provider.id != idProviderSelected" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_more.svg' | company" alt="">
              <img class="img-pointer" *ngIf="provider.id == idProviderSelected" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/expand_less.svg' | company" alt="">
            </div>
          </div>
        </div>
        <div class="card-body col pt-0" *ngIf="provider.id == idProviderSelected">
          <div class="row mb-3" *ngIf="assistance_plan_service?.sinister_apply == 1">
            <div class="col-md-8">
              <div>
                <label class="control-label" *ngIf="assistance_plan_service?.sinister_apply == 1">
                  {{ 'Provider user' | translate }}:
                </label>
                <div>
                  <select name="dentist" class="form-control" required [(ngModel)]="new_provider_id">
                    <option *ngIf="assistance_plan_service?.sinister_apply == 1" hidden [ngValue]="null">--- Seleccione un Proveedor ---
                    </option>
                    <option *ngFor="let user of siteUsers" [ngValue]="user.id">
                      {{ user.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="div-comment-provider w-100"  *ngIf="editticket.provider_status !== 3">
            <textarea rows="5" cols="10" class="form-control" placeholder="{{ 'Write a comment' | translate }}"
              [(ngModel)]="comment" name="comment" required>
            </textarea>
          </div>
          <div class="body-card-provider">
            <button class="btn primary-btn-green btn primary-btn-fw m-0">
              <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company" alt="">
              {{ 'To call' | translate }}
            </button>
            <button class="btn primary-btn btn primary-btn-fw m-0" (click)="Generar()"> {{ 'Assign' | translate }} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div  *ngIf="providersAll.length == 0"  class="row mt-3">
  <div style="text-align: center;">
    <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/alert.svg' | company" style="margin-top:85px; aspect-ratio: 1/1;" alt="">
    <h4>{{ "No providers" | translate }}</h4>
  </div>
</div>
</div>
</p-dialog>

<p-dialog
[(visible)]="showProviderUserDialog" [responsive]="true"
[modal]="true" [draggable]="false" [breakpoint]="500"
[blockScroll]="true" [positionTop]="100"
(onHide)="hideProviderUsers()">
  <ng-template pTemplate="header">
    
    {{ 'Provider Information' | translate }}
  
  </ng-template>
  
  <app-asign-user-provider
  [is_visible]="is_visible"
  [is_confirmation_visible]="is_confirmation_visible"
  [user_providers]="providers_app"
  [provider_app]="provider_app"
  [case_id]="case_id" 
  [is_reassign]="true"
  [last_provider_id]="lastProviderId"
  [isNormalCase]="isNormalCase"
  (done)="onSelectedUserProvider($event)"
  (closeconfirm)="closeConfirm($event)">
  </app-asign-user-provider>
</p-dialog>